<div [formGroup]="pickerForm">
  <div #dropDown="ngbDropdown"
       ngbDropdown
       role="group"
       [id]="dropdownId"
       [container]="container"
       [autoClose]="dropDownAutoClose"
       [placement]="placement"
       [dropdownClass]="dropdownMenuClass"
       (openChange)="onOpenChange($event)">
    <button ngbDropdownToggle type="button" class="form-control text-start d-flex align-items-center"
            [disabled]="readOnly || pickerForm.disabled" (blur)="onTouched()">
      <span class="d-inline-block w-100">
        <ng-template [ngTemplateOutlet]="pickerLabelTemplate" [ngTemplateOutletContext]="{formValue: pickerForm.value}"/>
      </span>
      @if (showClearButton && (pickerForm.value.dateRange?.startDate || pickerForm.value.dateRange?.endDate)) {
        <fa-icon class="me-1" icon="times"
                 [title]="'Clear' | messageTranslate" (click)="clearDateRange($event)"/>
      }
    </button>
    <div ngbDropdownMenu aria-label="dropDown">
      @if (dropDown.isOpen()) {
        @if (isPickerInCustomRangeMode()) {
          <div class="py-1 px-3 text-body-secondary">
            <app-date-time-range-select
              [label]="label"
              [showTime]="showTime"
              [placement]="'bottom'"
              [minDate]="minDate"
              [maxDate]="maxDate"
              [readOnly]="readOnly"
              [allowEqual]="allowEqual"
              [timezone]="timezone"
              [requiredFields]="requiredFields"
              [showErrors]="showErrors"
              [formControlName]="formControlName.DATE_RANGE"
              (navigate)="onCalendarPickerOpen()"
              (closed)="onCalendarPickerClosed()"/>
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-link p-0" (click)="clearDateRange()">
                {{'Clear' | messageTranslate}}
              </button>
              <button type="button" class="btn btn-secondary" aria-label="Close" (click)="closePicker()">
                {{'OK' | messageTranslate}}
              </button>
            </div>
          </div>
        } @else {
          <!-- yesterday  -->
          @if (groupedRelativeDateRanges.yesterday) {
            <ng-template [ngTemplateOutlet]="relativeDateRangeButton"
                         [ngTemplateOutletContext]="{rangeItem: groupedRelativeDateRanges.yesterday}"/>
            <div class="dropdown-divider"></div>
          }

          <!-- relative days -->
          @let showRelativeDays = !!groupedRelativeDateRanges.days?.length;
          @let showRelativeMonths = !!groupedRelativeDateRanges.months?.length;
          @if (showRelativeDays || showRelativeMonths) {
            @if (showRelativeDays) {
              @for (rangeItem of groupedRelativeDateRanges.days; track rangeItem.rangeType) {
                <ng-template [ngTemplateOutlet]="relativeDateRangeButton"
                             [ngTemplateOutletContext]="{rangeItem}"/>
              }
            }

            @if (showRelativeMonths) {
              @for (rangeItem of groupedRelativeDateRanges.months; track rangeItem.rangeType) {
                <ng-template [ngTemplateOutlet]="relativeDateRangeButton"
                             [ngTemplateOutletContext]="{rangeItem}"/>
              }
            }

            <ng-template [ngTemplateOutlet]="includeTodayToggle"
                         [ngTemplateOutletContext]="{label: showRelativeDays ? 'Include today' : 'Include current month'}"/>
            <div class="dropdown-divider"></div>
          }

          <!-- relative quarter -->
          @if (groupedRelativeDateRanges.quarter) {
            <ng-template [ngTemplateOutlet]="relativeDateRangeButton"
                         [ngTemplateOutletContext]="{rangeItem: groupedRelativeDateRanges.quarter}"/>
            <div class="dropdown-divider"></div>
          }

          <!-- custom range -->
          <button ngbDropdownItem (click)="setShowCustomRange(true)">
            {{'Custom range' | messageTranslate}}...
          </button>
        }
      }
    </div>
  </div>
  <!-- Use `controlDir.control` as source of errors so that bound errors in `FormControl` bound to this component will also show.
   In case there is none bound, use `pickerForm` date range control because that will always exist. -->
  @if (showErrors) {
    <app-errors [control]="controlDir?.control ?? pickerForm.get(formControlName.DATE_RANGE)"/>
  }
</div>

<ng-template #pickerLabelTemplate let-formValue="formValue">
  @let displayRelativeDate = mode === dateTimeRangeMode.RELATIVE && formValue.relativeDate;
  @if (displayRelativeDate || formValue.dateRange?.startDate || formValue.dateRange?.endDate) {
    @let displayText = getDisplayMessage(formValue.relativeDate, formValue.dateRange) | messageTranslate;
    @let tooltip = displayRelativeDate
      ? (getRelativeDateRangeTooltipMessage(formValue) | messageTranslate)
      : displayText;
    <span [title]="tooltip">{{displayText}}</span>
  } @else {
    <span class="text-body-secondary">{{placeholder}}</span>
  }
</ng-template>

<ng-template #relativeDateRangeButton let-rangeItem="rangeItem">
  <button ngbDropdownItem (click)="onSelect(rangeItem.rangeType)">
    <div class="d-flex justify-content-between gap-3">
      <div>{{rangeItem.label | messageTranslate}}<br/></div>
      <div class="text-body-secondary">{{rangeItem.subText | messageTranslate}}</div>
    </div>
  </button>
</ng-template>

<ng-template #includeTodayToggle let-label="label">
  @if (showIncludeToday) {
    @let toggleId = dropdownId + '_includeToday';
    @let includeTodayControl = pickerForm.get(formControlName.INCLUDE_TODAY);
    <div class="dropdown-item-text d-flex justify-content-between">
      <label class="form-check-label" [for]="toggleId">{{label | messageTranslate}}</label>
      <ui-switch size="small" [id]="toggleId" [checked]="includeTodayControl.value" [disabled]="includeTodayControl.disabled" (change)="setIncludeToday($event)" />
    </div>
  }
</ng-template>
